import { WriteForUsScreen } from 'app/features/blog/screens'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'
import Head from 'next/head'

export default function Page() {
  return (
    <>
      <Head>
        <title>Write For Us</title>
      </Head>
      <WriteForUsScreen />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user

  return {
    props: {
      user: user || null,
    },
  }
})
